import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-28 left-6 z-50 w-14 h-14 bg-wazin-gold hover:bg-wazin-gold-dark text-white rounded-full shadow-xl transition-all duration-300 flex items-center justify-center group hover:scale-110 border-2 border-white"
          aria-label="العودة لأعلى الصفحة"
        >
          <ChevronUp className="w-7 h-7 font-bold" />
        </button>
      )}
    </>
  );
};

export default BackToTop;
